import { createTV } from 'tailwind-variants';
import { validators } from 'tailwind-merge';

/**
 * `tv` that knows this library's tokens. tailwind-merge classifies an unknown
 * `text-*`, `shadow-*` or `bg-*` as a color, so without this
 * `text-title-lg text-fg` would merge down to `text-fg` and drop the size, and
 * `bg-brand bg-fill` would lose the gradient. Add every custom `--text-*`,
 * `--tracking-*`, `--shadow-*`, `--blur-*`, `--spacing-*`, `--ease-*`,
 * `--animate-*` and `--opacity-*` token of `theme.css` here, and every
 * `@utility`.
 */
export const tv = createTV({
  twMergeConfig: {
    extend: {
      theme: {
        text: [
          'display', 'title-lg', 'title-md', 'title-sm', 'lead', 'subtitle', 'body-lg', 'body-md', 'label', 'caption', 'overline', 'micro',
          'button-md', 'button-lg', 'tab', 'pill', 'reading-sm', 'reading-md', 'reading-lg', 'verse-number', 'book-title', 'chapter-title',
        ],
        tracking: ['code'],
        shadow: ['menu', 'dialog', 'pagination', 'control', 'brand-glow', 'knob', 'card-hover'],
        blur: ['glass', 'glow'],
        spacing: ['gutter', 'verse-number', 'safe-top', 'safe-right', 'safe-bottom', 'safe-left'],
        ease: ['standard'],
        animate: ['toast-in', 'toast-out', 'sheet-in', 'sheet-out', 'fade-in', 'fade-out', 'dialog-in', 'dialog-out', 'loader-dot', 'countdown', 'rise-in', 'ring-pop'],
        aspect: ['cover-tile', 'frame'],
      },
      classGroups: {
        'bg-image': ['bg-brand', 'bg-sheet-glow', 'bg-fade-canvas', 'bg-fade-reader', 'bg-cover-placeholder'],
        'bg-color': [{ highlight: ['red', 'lime', 'green', 'blue', 'violet', 'pink'] }],
        'gradient-ring': ['gradient-ring-selected', 'gradient-ring-swatch'],
        'mask-image': ['mask-fade-start'],
        'opacity': [{ opacity: ['disabled-row', 'disabled-field', 'disabled-control', 'disabled-pagination'] }],
        'pt': [{ 'pt-safe-offset': [validators.isInteger] }, 'pt-sheet-rest'],
        'pb': [{ 'pb-safe-offset': [validators.isInteger] }],
        'top': [{ 'top-safe-offset': [validators.isNumber] }],
        'inset-y': ['inset-y-sheet-rest'],
        'max-h': ['max-h-sheet', 'max-h-cover'],
        'min-h': ['min-h-app-screen'],
        'h': ['h-frame'],
        'max-w': ['max-w-frame'],
      },
    },
  },
});

export type { VariantProps } from 'tailwind-variants';
